module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/1-off-35205e4b1067c2737ccd8feb88ef85a4.png";